import { emailIcon, passwordIcon } from '../../../../assets';

const Fields = (vm) => {
    const inputClassName = `login-input h-full min-w-0 flex-1 appearance-none bg-white text-[11px] leading-none text-gray-700
        placeholder:text-gray-400 focus:outline-none lg:text-sm
        ${vm.loading ? 'cursor-not-allowed' : ''}`;

    return (
        <>
            <div>
                <label className="block text-[11px] font-medium text-gray-600 mb-0.5 lg:mb-0.5 lg:text-xs">
                    Correo
                </label>
                <div className="flex h-6 items-center border border-gray-300 bg-white px-2 lg:h-7 lg:px-2">
                    <img src={emailIcon} alt="" className="w-3 h-3 mr-1.5 opacity-60 lg:mr-2 lg:h-3.5 lg:w-3.5" />
                    <input
                        type="email"
                        value={vm.email}
                        onChange={(e) => vm.setEmail(e.target.value)}
                        className={inputClassName}
                        placeholder="example@esri.co"
                        disabled={vm.loading}
                        required
                    />
                </div>
            </div>
            <div>
                <label className="block text-[11px] font-medium text-gray-600 mb-0.5 lg:mb-0.5 lg:text-xs">
                    Contrase&ntilde;a
                </label>
                <div className="flex h-6 items-center border border-gray-300 bg-white px-2 lg:h-7 lg:px-2">
                    <img src={passwordIcon} alt="" className="w-3 h-3 mr-1.5 opacity-60 lg:mr-2 lg:h-3.5 lg:w-3.5" />
                    <input
                        type="password"
                        value={vm.password}
                        onChange={(e) => vm.setPassword(e.target.value)}
                        className={inputClassName}
                        placeholder="Contrasena"
                        disabled={vm.loading}
                        required
                    />
                </div>
            </div>
        </>
    );
};

export default Fields;
